import { IPrice } from '../../i18n/price/IPrice';
import { trackWithGoogleAnalytics } from '../shared/trackers/trackWithGoogleAnalytics';
import { adaptItemToRequest } from './adapters/adaptItemToRequest';
import { defaultCurrencyCode } from './constants/defaultCurrency';
import { adaptPriceToTrackingValue } from './adapters/adaptPriceToTrackingValue';
import { trackBingRevenue } from './trackBingRevenue';
import { trackConversion } from './trackConversion';
import { IItem } from './models/IItem';

interface IPurchaseEvent {
	transactionId: string;
	currency?: string;
	totalPrice: IPrice;
	items: IItem[];
	coupon?: string;
	entryDate: Date | undefined;
	exitDate: Date | undefined;
	prefilledVehicle?: boolean;
	loyaltyTitle?: string;
	loyaltyPoints?: number;
}

/**
 * https://developers.google.com/analytics/devguides/collection/gtagjs/enhanced-ecommerce#measure_purchases
 */
export function trackPurchase({
	transactionId,
	entryDate,
	exitDate,
	currency = defaultCurrencyCode,
	totalPrice,
	coupon,
	items,
	prefilledVehicle,
	loyaltyTitle,
	loyaltyPoints,
}: IPurchaseEvent) {
	// Send to Google Analytic
	trackWithGoogleAnalytics('event', 'purchase', {
		transaction_id: transactionId,
		affiliation: 'CLT',
		currency,
		value: adaptPriceToTrackingValue(totalPrice),
		items: items.map(adaptItemToRequest),
		coupon,
		prefilled_vehicle: prefilledVehicle,
		loyalty_title: loyaltyTitle,
		loyalty_points: loyaltyPoints,
	});

	// Tracked by Aeroparker and Adara
	trackConversion({
		currency,
		entryDate,
		exitDate,
		totalPrice,
		transactionId,
	});

	// Tracked by Aeroparker
	trackBingRevenue({
		totalRevenue: totalPrice,
		currency,
	});
}
